var _path, _g, _path2, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 50,
    viewBox: "0 0 71 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7054 16.6752C25.7082 16.6718 25.711 16.6685 25.7138 16.6652C25.7173 16.6693 25.7208 16.6735 25.7244 16.6778C25.9016 16.8897 26.137 17.2057 26.4129 17.6057C26.963 18.4032 27.6534 19.5046 28.3292 20.706C29.0054 21.9081 29.6615 23.2004 30.147 24.381C30.6398 25.5793 30.9303 26.6009 30.9303 27.285C30.9303 27.9698 30.7954 28.648 30.5333 29.2807C30.2712 29.9135 29.887 30.4884 29.4027 30.9726C28.4247 31.9506 27.0982 32.5 25.715 32.5C24.3319 32.5 23.0054 31.9505 22.0274 30.9724C21.0494 29.9944 20.5 28.6679 20.5 27.2847C20.5 26.6006 20.7905 25.5784 21.2834 24.3791C21.7689 23.1977 22.4249 21.9043 23.1011 20.7016C23.777 19.4995 24.4673 18.3979 25.0173 17.601C25.2932 17.2013 25.5284 16.8861 25.7054 16.6752Z",
    stroke: "#7DD8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_581_15157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3579 29.4213C21.9289 29.5959 22.6547 28.8777 22.9789 27.8171C23.3032 26.7566 23.1031 25.7554 22.532 25.5808C21.961 25.4062 21.2352 26.1244 20.911 27.1849C20.5867 28.2454 20.7868 29.2467 21.3579 29.4213Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7054 28.6752C39.7082 28.6718 39.711 28.6685 39.7138 28.6652C39.7173 28.6693 39.7208 28.6735 39.7244 28.6778C39.9016 28.8897 40.137 29.2057 40.4129 29.6057C40.963 30.4032 41.6534 31.5046 42.3292 32.706C43.0054 33.9081 43.6615 35.2004 44.147 36.381C44.6398 37.5793 44.9303 38.6009 44.9303 39.285C44.9303 39.9698 44.7954 40.648 44.5333 41.2807C44.2712 41.9135 43.887 42.4884 43.4027 42.9726C42.4247 43.9506 41.0982 44.5 39.715 44.5C38.3319 44.5 37.0054 43.9505 36.0274 42.9724C35.0494 41.9944 34.5 40.6679 34.5 39.2847C34.5 38.6006 34.7905 37.5784 35.2834 36.3791C35.7689 35.1977 36.4249 33.9043 37.1011 32.7016C37.777 31.4995 38.4673 30.3979 39.0173 29.601C39.2932 29.2013 39.5284 28.8861 39.7054 28.6752Z",
    stroke: "#7DD8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7054 11.6752C52.7082 11.6718 52.711 11.6685 52.7138 11.6652C52.7173 11.6693 52.7208 11.6735 52.7244 11.6778C52.9016 11.8897 53.137 12.2057 53.4129 12.6057C53.963 13.4032 54.6534 14.5046 55.3292 15.706C56.0054 16.9081 56.6615 18.2004 57.147 19.381C57.6398 20.5793 57.9303 21.6009 57.9303 22.285C57.9303 22.9698 57.7954 23.648 57.5333 24.2807C57.2712 24.9135 56.887 25.4884 56.4027 25.9726C55.4247 26.9506 54.0982 27.5 52.715 27.5C51.3319 27.5 50.0054 26.9505 49.0274 25.9724C48.0494 24.9944 47.5 23.6679 47.5 22.2847C47.5 21.6006 47.7905 20.5784 48.2834 19.3791C48.7689 18.1977 49.4249 16.9043 50.1011 15.7016C50.777 14.4995 51.4673 13.3979 52.0173 12.601C52.2932 12.2013 52.5284 11.8861 52.7054 11.6752Z",
    stroke: "#7DD8E9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_581_15157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3579 24.4213C48.9289 24.5959 49.6547 23.8777 49.9789 22.8171C50.3032 21.7566 50.1031 20.7554 49.532 20.5808C48.961 20.4062 48.2352 21.1244 47.911 22.1849C47.5867 23.2454 47.7868 24.2467 48.3579 24.4213Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_581_15157",
    x: 0.755859,
    y: 5.55469,
    width: 42.3789,
    height: 43.8926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_581_15157"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_581_15157",
    x: 27.7559,
    y: 0.554688,
    width: 42.3789,
    height: 43.8926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_581_15157"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainIcon);
export default __webpack_public_path__ + "static/media/RainIcon.d58af6942f7b4a655585a82972a0404c.svg";
export { ForwardRef as ReactComponent };